import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://st1.routing.nonp.complydome.io/config/application-constants/nonp-st1',
  stripePubKey: 'pk_test_51R1XzFRw67O6xpVUSWusDaqxYaAO9lB5FippWBb3CIiokqN0SpLdbbTuDOmT5Yy9dCX9w46XFoHYusB8kzQAJwyu00136VOEFB',
  syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1JBaF5cXmRCf1JpRHxbf1x2ZFNMYVhbRHFPIiBoS35RcERjWX1feHVTR2BfVEd+VEFY',
  tidioScriptUrl: '//code.tidio.co/umghtd43atmsogxzl4shkbs1lphhujma.js',
  socketUrl: 'wss://st1.routing.nonp.complydome.io/messaging-service/ws/user',
  baseSocketUrl: 'wss://st1.routing.nonp.complydome.io/messaging-service',
};
